import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notificationsSubject: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public notifications$ = this.notificationsSubject.asObservable();

  constructor(){}

  public updateNotifications(value: number): void {
      this.notificationsSubject.next(value);
  }
}
